var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-num',{staticClass:"k-num--rate",attrs:{"skin":_vm.skin,"value":_vm.value * 100,"sign":_vm.sign,"fixed":2,"unit":"%"}})}
var staticRenderFns = []

export { render, staticRenderFns }